import { Box, Tabs, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { TitleTypographyTabs } from "../../common/components/TitleTypography";
import { useUserRoles } from "../../hooks/useUserRole";
import { getAccessibleTabs } from "../../helpers/check-role-permission";
import { ROUTES } from "../Routes/routes";
import ProtectedTab from "../../common/components/ProtectedTab";
import { PAGE_KEYS } from "../../config/permissions/page-key";
import TimeFrame from "./TimeFrame";
import TimeZone from "./TimeZone";

const TimeSetupWrapper = () => {
  const { roles } = useUserRoles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Fetch accessible tabs for this component
   // 0 - Time Frame, 1 - Time Zone
  const accessibleTabs = getAccessibleTabs(roles, ROUTES.SETUP.timeSetup);

  const tabOrder = [PAGE_KEYS.TIME_SETUP_FRAME, PAGE_KEYS.TIME_SETUP_ZONE];

  const [tab, setTab] = useState(() => {
    return accessibleTabs.includes(accessibleTabs[0]) || tabOrder[0];
  });

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  const title = (
    <Box
      sx={
        isMobile
          ? { display: "flex", justifyContent: "end", width: "100%" }
          : {}
      }
    >
      <Typography variant="h6">Time Setup</Typography>
    </Box>
  );

  return (
    <Box>
      <TitleTypographyTabs>
        <>
          {isMobile && title}
          <Tabs value={tab} onChange={handleChange}>
            <ProtectedTab
              component={ROUTES.SETUP.timeSetup}
              tabName={PAGE_KEYS.TIME_SETUP_FRAME}
              accessibleTabs={accessibleTabs}
              value={PAGE_KEYS.TIME_SETUP_FRAME}
              label="Time Frame"
              id="time-frame"
            />
            <ProtectedTab
              component={ROUTES.SETUP.timeSetup}
              tabName={PAGE_KEYS.TIME_SETUP_ZONE}
              accessibleTabs={accessibleTabs}
              value={PAGE_KEYS.TIME_SETUP_ZONE}
              label="Time Zone"
              id="time-zone"
            />
          </Tabs>
          {!isMobile && title}
        </>
      </TitleTypographyTabs>
      <Box elevation={3}>
        <div>
          <div>
            {tab === PAGE_KEYS.TIME_SETUP_FRAME && <TimeFrame />}
            {tab === PAGE_KEYS.TIME_SETUP_ZONE && <TimeZone />}
          </div>
        </div>
      </Box>
    </Box>
  );
};

export default TimeSetupWrapper;
